import { IQuestion } from '../interfaces/Question';
import { UPDATE_REPLY_MESSAGE } from './actions';

export const updateReplyMessage = (payload: IQuestion | null) => ({
  type: UPDATE_REPLY_MESSAGE,
  payload
});